import React from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"
import withTranslations from "~/components/_hocs/withTranslations"

const NassauTabsRow = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 16px;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.borderGray || '#D5D8DB'};
`

const NassauTab = styled.button`
  padding: 10px 20px;
  font-family: ${(p) => p.theme?.fonts?.avenirNextMedium || 'inherit'};
  font-size: 0.9375rem;
  color: ${(p) => (p.$active ? p.theme?.colors?.primary || '#3089f3' : '#6c6d6e')};
  background: none;
  border: none;
  border-bottom: 2px solid ${(p) => (p.$active ? p.theme?.colors?.primary || '#3089f3' : 'transparent')};
  margin-bottom: -1px;
  cursor: pointer;

  &:hover {
    color: ${(p) => p.theme?.colors?.primary || '#3089f3'};
  }
`

@inject((all) => ({
  nassauSearchTab: all.store.trafficLookup.nassauSearchTab,
  setNassauSearchTab: all.store.trafficLookup.setNassauSearchTab,
}))
@observer
class NassauTabs extends React.Component {
  render() {
    return (
      <NassauTabsRow>
        <NassauTab
          type="button"
          $active={this.props.nassauSearchTab === 'plate'}
          onClick={() => this.props.setNassauSearchTab('plate')}
        >
          {this.props.translate("nassau.tabPlate")}
        </NassauTab>
        <NassauTab
          type="button"
          $active={this.props.nassauSearchTab === 'license'}
          onClick={() => this.props.setNassauSearchTab('license')}
        >
          {this.props.translate("nassau.tabLicense")}
        </NassauTab>
      </NassauTabsRow>
    )
  }
}

export default withTranslations(NassauTabs, "form.general")
